module.exports = __webpack_public_path__ + "r-v3/img/ico_my_setting_white.f8eff9a8.svg";